// extracted by mini-css-extract-plugin
export default {"button":"_2Ifj0","title":"_3kLOU","addToWalletTitle":"_1hVbN","spinnerContainer":"_18oDR"};